import { render, staticRenderFns } from "./communityresidentialarea.vue?vue&type=template&id=56c20761&scoped=true&"
import script from "./communityresidentialarea.vue?vue&type=script&lang=js&"
export * from "./communityresidentialarea.vue?vue&type=script&lang=js&"
import style0 from "./communityresidentialarea.vue?vue&type=style&index=0&id=56c20761&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c20761",
  null
  
)

export default component.exports